/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable object-curly-newline */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-extraneous-dependencies */
import React, {
  useState, useEffect, useContext, useMemo,
} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { ChevronsUpDown, ChevronUp, ChevronDown } from 'lucide-react';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import { Navbar, Sidebar } from '../../components';
import RowActionMenu from '../../components/RowActionMenu';
import { UserContext } from '../../contexts/User';
import { NotificationContext } from '../../contexts/Notification';
import { getMemberRoleLevel } from '../../utils/permissions';
import { accountTypeLevel } from '../../constants/accountTypes';
import useQueryParams from '../../hooks/useQueryParams';
import EmptyIcon from '../../images/emptyRequests.svg';
import RequestModal from './RequestModal';
import RequestViewModal from './RequestViewModal';
import RequestDeleteModal from './RequestDeleteModal';

const PAGE_SIZE = 10;
const TAB_KEYS = ['Submitted', 'Approved', 'Denied', 'All'];
const DATE_OPTS = { weekday: 'short', month: 'short', day: '2-digit', year: 'numeric' };

const PILL = {
  Submitted: { bg: '#fde6d2', fg: '#F19235' },
  Approved: { bg: '#eef5ea', fg: '#53A551' },
  Denied: { bg: '#fdebe6', fg: '#b94f3c' },
};

function StatusPill({ status }) {
  const c = PILL[status] || PILL.Denied;
  return (
    <span
      className="inline-flex items-center px-2.5 py-0.5 rounded-full"
      style={{ backgroundColor: c.bg, color: c.fg, fontSize: '11px', fontWeight: 600 }}
    >
      {status}
    </span>
  );
}

function SortIcon({ active, dir }) {
  if (!active) return <ChevronsUpDown size={12} className="text-ink-500" />;
  return dir === 'asc' ? <ChevronUp size={12} /> : <ChevronDown size={12} />;
}

function ReasonCell({ reason }) {
  if (!reason) return <span className="text-ink-500">—</span>;
  return (
    <span
      title={reason}
      className="text-ink-900 break-words"
      style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}
    >
      {reason}
    </span>
  );
}

function InlinePagination({
  page, pageSize, total, onPageChange,
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(total, page * pageSize);
  const pages = useMemo(() => {
    const max = 5;
    if (totalPages <= max) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const half = Math.floor(max / 2);
    let from = Math.max(1, page - half);
    const to = Math.min(totalPages, from + max - 1);
    from = Math.max(1, to - max + 1);
    return Array.from({ length: to - from + 1 }, (_, i) => from + i);
  }, [page, totalPages]);

  return (
    <div className="flex items-center justify-between gap-3 px-5 py-3" style={{ borderTop: '1px solid #f1f2f5' }}>
      <div className="flex items-center gap-1 flex-wrap">
        <button type="button" onClick={() => onPageChange(Math.max(1, page - 1))} disabled={page === 1} aria-label="Previous page" className="w-8 h-8 inline-flex items-center justify-center rounded-[6px] text-ink-900 hover:bg-surface-1 disabled:opacity-40 disabled:cursor-not-allowed transition">‹</button>
        {pages.map((p) => (
          <button key={p} type="button" onClick={() => onPageChange(p)} className={`min-w-[32px] h-8 px-2 inline-flex items-center justify-center rounded-[6px] text-sm font-medium transition ${p === page ? 'bg-brand-700 text-white' : 'text-ink-900 hover:bg-surface-1'}`}>{p}</button>
        ))}
        <button type="button" onClick={() => onPageChange(Math.min(totalPages, page + 1))} disabled={page === totalPages || total === 0} aria-label="Next page" className="w-8 h-8 inline-flex items-center justify-center rounded-[6px] text-ink-900 hover:bg-surface-1 disabled:opacity-40 disabled:cursor-not-allowed transition">›</button>
      </div>
      <span className="text-sm text-ink-900 tabular-nums">
        {start}
        -
        {end}
        {' of '}
        {total}
      </span>
    </div>
  );
}

function PtoRequest() {
  const {
    member, accessToken, redirect, updateTokens,
  } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);
  const [loading, setLoading] = useState(false);
  const [policies, setPolicies] = useState([]);
  const [balances, setBalances] = useState([]);
  const [requests, setRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState({});
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [tab, setTab] = useState('Submitted');
  const [page, setPage] = useState(1);

  const getData = async () => {
    try {
      setLoading(true);
      const response = await sendRequest({
        method: 'get', url: API.WORKSPACE.getOffTimeData(member.workspaceId, member.id),
      });
      if (response.data) {
        setPolicies(response.data.ptoPolicies);
        setBalances(response.data.ptoBalances);
        setRequests(response.data.ptoRequests || []);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const queryParams = useQueryParams();
  const queryAccessToken = queryParams.get('accessToken');

  useEffect(() => {
    if (!accessToken && !queryAccessToken) redirect('/workspaces');
    if (queryAccessToken) updateTokens({ accessToken: queryAccessToken });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (accessToken && queryAccessToken) redirect('/pto/requests');
  }, [accessToken, queryAccessToken, redirect]);

  // Decorate requests with the policy name + formatted fields, keeping the raw request for the modals.
  const decorated = useMemo(() => (requests || []).map((request) => {
    const policy = policies?.find((p) => p.id === request.policyId);
    return {
      raw: request,
      id: request.id,
      policyName: policy ? policy.name : '',
      reason: request.reason,
      start: new Date(request.startDate),
      end: new Date(request.endDate),
      hours: request.totalHours || 0,
      status: request.status,
      requestedOn: new Date(request.createdAt),
    };
  }), [requests, policies]);

  const counts = useMemo(() => ({
    Submitted: decorated.filter((r) => r.status === 'Submitted').length,
    Approved: decorated.filter((r) => r.status === 'Approved').length,
    Denied: decorated.filter((r) => r.status === 'Denied').length,
    All: decorated.length,
  }), [decorated]);

  const scoped = useMemo(
    () => (tab === 'All' ? decorated : decorated.filter((r) => r.status === tab)),
    [decorated, tab],
  );

  const [sortKey, setSortKey] = useState('requestedOn');
  const [sortDir, setSortDir] = useState('desc');
  const toggleSort = (key) => {
    if (key === sortKey) setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    else { setSortKey(key); setSortDir('asc'); }
  };

  const sorted = useMemo(() => {
    const arr = [...scoped];
    arr.sort((a, b) => {
      let av; let bv;
      if (sortKey === 'policy') { av = a.policyName.toLowerCase(); bv = b.policyName.toLowerCase(); } else if (sortKey === 'hours') { av = a.hours; bv = b.hours; } else if (sortKey === 'status') { av = a.status; bv = b.status; } else if (sortKey === 'start') { av = a.start.getTime(); bv = b.start.getTime(); } else if (sortKey === 'end') { av = a.end.getTime(); bv = b.end.getTime(); } else { av = a.requestedOn.getTime(); bv = b.requestedOn.getTime(); }
      const cmp = av < bv ? -1 : av > bv ? 1 : 0;
      return sortDir === 'asc' ? cmp : -cmp;
    });
    return arr;
  }, [scoped, sortKey, sortDir]);

  // Approved/Denied tabs show who actioned it, matching the Team Off page.
  const extraColumn = useMemo(() => {
    if (tab === 'Approved') return { label: 'Approved By', get: (r) => r.raw?.manager?.user?.fullName ?? '—' };
    if (tab === 'Denied') return { label: 'Denied By', get: (r) => r.raw?.manager?.user?.fullName ?? '—' };
    if (tab === 'All') return { label: 'Approved / Denied By', get: (r) => r.raw?.manager?.user?.fullName ?? '—' };
    return null;
  }, [tab]);

  useEffect(() => { setPage(1); }, [tab]);

  const total = sorted.length;
  const pageItems = sorted.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const sortHeader = (label, key) => (
    <button
      type="button"
      onClick={() => toggleSort(key)}
      className="inline-flex items-center gap-1 uppercase tracking-wider text-left"
      style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.05em', lineHeight: '16px', color: '#546077' }}
    >
      <span>{label}</span>
      <span className="flex-shrink-0 inline-flex items-center"><SortIcon active={sortKey === key} dir={sortDir} /></span>
    </button>
  );

  const formatDate = (d) => d.toLocaleDateString('en-US', DATE_OPTS);
  const formatHHMM = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
  };

  const openView = (r) => { setSelectedRequest(r.raw); setShowViewModal(true); };
  const openEdit = (r) => { setSelectedRequest(r.raw); setShowEditModal(true); };
  const openDelete = (r) => { setSelectedRequest(r.raw); setShowDeleteModal(true); };

  const itemsFor = (r) => {
    if (r.status === 'Submitted') {
      return [
        { label: 'View Request', onClick: () => openView(r) },
        { label: 'Edit Request', onClick: () => openEdit(r) },
        { label: 'Delete Request', onClick: () => openDelete(r), destructive: true },
      ];
    }
    if (r.status === 'Approved') {
      return [{ label: 'View Request', onClick: () => openView(r) }];
    }
    // Denied
    return [
      { label: 'View Request', onClick: () => openView(r) },
      { label: 'Resubmit Request', onClick: () => openEdit(r) },
      { label: 'Delete Request', onClick: () => openDelete(r), destructive: true },
    ];
  };

  const handleCloseModal = (refresh = true) => {
    setShowEditModal(false);
    setShowViewModal(false);
    setShowDeleteModal(false);
    setShowRequestModal(false);
    if (refresh) getData();
  };

  const handleDelete = async () => {
    const { success } = await sendRequest({
      method: 'delete',
      url: API.WORKSPACE.deleteOffTimeRequest(member.workspaceId, selectedRequest.id),
    });
    if (success) {
      displayNotification({ message: 'Request has been deleted successfully.', severity: 'success' });
      setShowDeleteModal(false);
      getData();
    } else {
      displayNotification({ message: 'There was an issue deleting the request.', severity: 'error' });
    }
  };

  const title = getMemberRoleLevel(member) >= accountTypeLevel['Workspace admin']
    ? 'Personal Time Off Request' : 'Time Off Request';

  if (!accessToken || !member) return null;

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="screen-wrapper">
        <div className="screen-header" style={{ fontFamily: 'Inter, sans-serif' }}>
          <div className="flex flex-col gap-3 mb-4 sm:flex-row sm:items-start sm:justify-between">
            <div className="min-w-0 flex-1">
              <h1
                className="font-bold text-ink-900 leading-tight truncate text-2xl lg:text-[32px] lg:leading-10"
                data-testid="title"
                data-tour="pto"
              >
                {title}
              </h1>
            </div>
          </div>

          <div className="rounded-xl bg-white border border-surface-2 shadow-[0_1px_2px_rgba(14,30,64,0.04)] overflow-hidden">
            {/* Top bar: tabs + request button */}
            <div className="flex flex-col xl:flex-row xl:items-center gap-3 px-5 pt-4 pb-3 border-b border-surface-1">
              <div className="flex items-center gap-6 overflow-x-auto">
                {TAB_KEYS.map((t) => {
                  const active = tab === t;
                  return (
                    <button
                      key={t}
                      type="button"
                      onClick={() => setTab(t)}
                      className={`relative text-sm font-medium transition whitespace-nowrap ${active ? 'text-ink-900' : 'text-ink-500 hover:text-ink-900'}`}
                    >
                      {t}
                      {' '}
                      <span className="text-ink-500">
                        (
                        {counts[t]}
                        )
                      </span>
                      {active && <span className="absolute left-0 right-0 -bottom-3 h-0.5 bg-brand-700 rounded-full" />}
                    </button>
                  );
                })}
              </div>
              <div className="flex-1 xl:flex xl:justify-end">
                <button
                  type="button"
                  onClick={() => setShowRequestModal(true)}
                  disabled={loading}
                  className="inline-flex items-center h-10 px-4 rounded-[8px] bg-[#53A551] text-white text-sm font-semibold hover:bg-[#458a44] disabled:opacity-50 transition whitespace-nowrap"
                >
                  Request Time Off
                </button>
              </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full table-fixed" style={{ minWidth: extraColumn ? '1050px' : '900px' }}>
                <thead style={{ borderBottom: '1px solid #f1f2f5' }}>
                  <tr className="text-left bg-surface-page align-top">
                    <th style={{ padding: '12px 8px 12px 16px', width: '15%' }}>{sortHeader('Policy Name', 'policy')}</th>
                    <th style={{ padding: '12px 8px', width: '18%' }}>
                      <span className="uppercase tracking-wider" style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.05em', color: '#546077' }}>Reason</span>
                    </th>
                    <th style={{ padding: '12px 8px', width: '13%' }}>{sortHeader('Start', 'start')}</th>
                    <th style={{ padding: '12px 8px', width: '13%' }}>{sortHeader('End', 'end')}</th>
                    <th style={{ padding: '12px 8px', width: '9%' }}>{sortHeader('Hours', 'hours')}</th>
                    <th style={{ padding: '12px 8px', width: '10%' }}>{sortHeader('Status', 'status')}</th>
                    <th style={{ padding: '12px 8px', width: '13%' }}>{sortHeader('Requested On', 'requestedOn')}</th>
                    {extraColumn && (
                      <th style={{ padding: '12px 8px', width: '12%' }}>
                        <span className="uppercase tracking-wider" style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.05em', color: '#546077' }}>{extraColumn.label}</span>
                      </th>
                    )}
                    <th style={{ padding: '12px 8px', width: '64px' }} />
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan={extraColumn ? 9 : 8} style={{ padding: '48px 20px' }}>
                        <div className="flex items-center justify-center"><CircularProgress size={24} sx={{ color: 'inherit' }} /></div>
                      </td>
                    </tr>
                  )}
                  {!loading && total === 0 && (
                    <tr>
                      <td colSpan={extraColumn ? 9 : 8} style={{ padding: '40px 20px' }}>
                        <div className="flex flex-col items-center gap-3">
                          <img src={EmptyIcon} alt="" width={48} height={48} />
                          <span className="text-sm text-ink-500">No requests found.</span>
                        </div>
                      </td>
                    </tr>
                  )}
                  {!loading && pageItems.map((r) => (
                    <tr key={r.id} className="hover:bg-surface-page transition align-top" style={{ borderTop: '1px solid #f1f2f5', fontSize: '14px' }}>
                      <td className="text-ink-900 break-words" style={{ padding: '12px 8px 12px 16px' }}>{r.policyName}</td>
                      <td style={{ padding: '12px 8px' }}><ReasonCell reason={r.reason} /></td>
                      <td className="text-ink-900 tabular-nums" style={{ padding: '12px 8px' }}>{formatDate(r.start)}</td>
                      <td className="text-ink-900 tabular-nums" style={{ padding: '12px 8px' }}>{formatDate(r.end)}</td>
                      <td className="text-ink-900 tabular-nums" style={{ padding: '12px 8px' }}>{formatHHMM(r.hours)}</td>
                      <td style={{ padding: '12px 8px' }}><StatusPill status={r.status} /></td>
                      <td className="text-ink-900 tabular-nums" style={{ padding: '12px 8px' }}>{formatDate(r.requestedOn)}</td>
                      {extraColumn && (
                        <td className="text-ink-900 break-words" style={{ padding: '12px 8px' }}>{extraColumn.get(r)}</td>
                      )}
                      <td style={{ padding: '12px 8px', verticalAlign: 'middle' }}>
                        <RowActionMenu
                          orientation="vertical"
                          iconSize={16}
                          ariaLabel="Open actions"
                          triggerClassName="inline-flex items-center justify-center p-1 rounded hover:bg-surface-1 text-ink-500 transition bg-transparent border-0 align-middle"
                          items={itemsFor(r)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {!loading && total > 0 && (
              <InlinePagination page={page} pageSize={PAGE_SIZE} total={total} onPageChange={setPage} />
            )}
          </div>
        </div>
      </div>

      {showRequestModal && (
        <RequestModal
          closeModal={handleCloseModal}
          getData={getData}
          balances={balances}
          requests={requests}
          policies={policies}
          setLoading={setLoading}
        />
      )}
      {showEditModal && (
        <RequestModal
          closeModal={handleCloseModal}
          getData={getData}
          balances={balances}
          requests={requests}
          policies={policies}
          setLoading={setLoading}
          editRequest={selectedRequest}
        />
      )}
      {showViewModal && (
        <RequestViewModal
          closeModal={handleCloseModal}
          balances={balances}
          policies={policies}
          selectedRequest={selectedRequest}
        />
      )}
      {showDeleteModal && (
        <RequestDeleteModal
          closeModal={() => setShowDeleteModal(false)}
          handleDelete={handleDelete}
          request={selectedRequest}
        />
      )}
    </>
  );
}

export default PtoRequest;
